import PropTypes from 'prop-types';
import React from 'react';

import CheckOption from './CheckOption';
import Section from './Section';

// Single-select facet whose options nest (recency windows) — exactly one option
// is active, and the widest option means "no filter".
const RadioFacet = ({ title, options, counts, selected, noFilterKey, onSelect }) => (
  <Section title={title} badge={selected === noFilterKey ? 0 : 1}>
    <div className="ab-opts" role="group" aria-label={title}>
      {options.map((o) => (
        <CheckOption
          key={o.key}
          label={o.label}
          count={(counts || {})[o.key] || 0}
          on={selected === o.key}
          onClick={() => onSelect(o.key)}
        />
      ))}
    </div>
  </Section>
);
RadioFacet.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  counts: PropTypes.object,
  selected: PropTypes.string.isRequired,
  noFilterKey: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default RadioFacet;
